import { render, staticRenderFns } from "./VisitInfoV2.vue?vue&type=template&id=63690770&"
import script from "./VisitInfoV2.vue?vue&type=script&lang=ts&"
export * from "./VisitInfoV2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports